import PlansInterceptor from '../PlansInterceptor'

const api = new PlansInterceptor()

export default {

  createFormaDePagamento(body: any): any {
    return api.post(`/formas-pagamento`, body)
  },

  getFormasDePagamento(): any {
    return api.get(`/formas-pagamento`)
  },
}